/*
 * @Author: wxb
 * @Date: 2021-07-06 17:01:28
 * @LastEditTime: 2021-07-28 17:16:06
 * @LastEditors: wxb
 * @Description:
 * @FilePath: \ui-projectd:\projects\zhzj\ui-djz\src\api\document\index.js
 */

import request from '@/utils/request'
import qs from 'qs'

/**
 * @description: 获取文库列表
 * @param {*} params
 * @return {*}
 */
export function search(params) {
  return request({
    url: '/api/company/vLibrary/search',
    method: 'post',
    data: qs.stringify(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * @description: 获取文库详情
 * @param {*} params
 * @return {*}
 */
export function fileDetails(params) {
  return request({
    url: '/api/company/loginVlibrary/fileDetails',
    method: 'post',
    data: qs.stringify(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * @description: 获取附件详细信息
 * @param {*} params
 * @return {*}
 */
export function documentDetails(params) {
  return request({
    url: '/api/company/document/getFile',
    method: 'get',
    params
  })
}

/**
 * @description: 获取文件预览流
 * @param {*} params
 * @return {*}
 */
export function preview(params) {
  return request({
    url: '/api/company/document/preview',
    method: 'get',
    params,
    timeout: 100000,
    responseType: 'blob'
  })
}
